import React, { useState, useEffect } from 'react';
import ToggleSwitch from '../../components/ToggleSwitch';
import LeadsEarningConfig from '../../models/LeadsEarningConfig.js';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { leadsEarningConfig, setLeadsEarningConfig } = props;
  const leadsEarningConfigObj = new LeadsEarningConfig(leadsEarningConfig);

  const [branches, setBranches] = useState([]);
  const [branchesApi] = getApi("branches");

  const [serviceTypes, setServiceTypes] = useState([]);
  const [serviceTypeApi] = getApi("serviceType");

  useEffect(()=>{
    fetchApiData(branchesApi, "branches", { fields: 'options' }, setBranches);
    fetchServiceTypes([1, 2]);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error("Something Went Wrong !");
    }
  }

  const fetchServiceTypes = async (serviceTypeIds) => {
    try {
      if(serviceTypeIds.length !== 0){
        const response = await serviceTypeApi({ filters: { parent_ids: serviceTypeIds } }).unwrap();
        let filteredData = response.data.service_types.map(item =>
         {return { ...item, 'displayValue': `${item.parent_name} - ${item.name}` }}
        )
        setServiceTypes(filteredData);
      } else{
        const response = await serviceTypeApi({ filters: { parent_ids: [0] }, fields: 'options' }).unwrap();
        setServiceTypes(response.data.service_types);
      }
    } catch (error) {
    }
  }

  const validateValue = (field) => {
    leadsEarningConfigObj.validate(field);
  }

  const changeValue = (field, value) => {
    leadsEarningConfigObj[field] = value;
    validateValue(field);
    setLeadsEarningConfig(leadsEarningConfigObj.toStateJson());
  }

  const onMultiSelectSelect = (key, selectedItem, array_key = false) => {
    if(array_key){
      leadsEarningConfigObj[key].push(selectedItem.id);
    } else {
      leadsEarningConfigObj[key] = selectedItem.id;
    }
    validateValue(key);
    setLeadsEarningConfig(leadsEarningConfigObj.toStateJson());
  }

  const onMultiSelectRemove = (key, removedItem, array_key = false) => {
    if(array_key){
      leadsEarningConfigObj[key] = leadsEarningConfigObj[key].filter((item) => item !== removedItem.id);
    } else{
      leadsEarningConfigObj[key] = "";
    }
    validateValue(key);
    setLeadsEarningConfig(leadsEarningConfigObj.toStateJson());
  }

  return <React.Fragment>
    <div className="mt-4">
      <div className="row">
        <div className="col-md-4 my-2">
          <label htmlFor='branch_id' className="form-label mb-1">Circle</label>
          <Multiselect
            id='branch_id'
            selectedValues={branches.filter((item) => item.id === parseInt(leadsEarningConfigObj.branch_id))}
            options={branches}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("branch_id", selectedItem, false)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("branch_id", removedItem, false)}
            placeholder='Select Circles'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
          />
          <div id='branch_id_help' className='form-text text-danger mt-0'>
            {leadsEarningConfigObj.errors.branch_id}
          </div>
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor='service_type_id' className="form-label mb-1">Service Type</label>
          <Multiselect
            id='service_type_id'
            selectedValues={serviceTypes.filter((item) => leadsEarningConfigObj.service_type_id.includes(item.id))}
            options={serviceTypes}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("service_type_id", selectedItem, true)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("service_type_id", removedItem, true)}
            placeholder='Select Service Type'
            displayValue='displayValue'
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
          />
          <div id='service_type_id_help' className='form-text text-danger mt-0'>
            {leadsEarningConfigObj.errors.service_type_id}
          </div>
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="monthly_min_target" className="form-label mb-1">Monthly Minimum Target</label>
          <input
            id="monthly_min_target"
            value={leadsEarningConfigObj.monthly_min_target}
            onChange={(e) => changeValue('monthly_min_target', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="montly_min_target_help"
            placeholder='Enter monthly minimum target'
          />
          <div id="montly_min_target_help" className="form-text text-danger mt-0">
            {leadsEarningConfigObj.errors.monthly_min_target}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className="col-md-4 my-2">
          <label htmlFor="monthly_target" className="form-label mb-1">Monthly Target</label>
          <input
            id="monthly_target"
            value={leadsEarningConfigObj.monthly_target}
            onChange={(e) => changeValue('monthly_target', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="monthly_target_help"
            placeholder='Enter monthly target'
          />
          <div id="monthly_target_help" className="form-text text-danger mt-0">
            {leadsEarningConfigObj.errors.monthly_target}
          </div>
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="per_activation_rate" className="form-label mb-1">Per Activation Rate</label>
          <input
            id="per_activation_rate"
            value={leadsEarningConfigObj.per_activation_rate}
            onChange={(e) => changeValue('per_activation_rate', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="per_activation_rate_help"
            placeholder='Enter per activation rate'
          />
          <div id="per_activation_rate_help" className="form-text text-danger mt-0">
            {leadsEarningConfigObj.errors.per_activation_rate}
          </div>
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="is_active" className="form-label mb-1">Select Active Status</label>
          <ToggleSwitch
            id="is_active"
            label_left="Inactive"
            label_right ="Active"
            onChange={(e) => changeValue('is_active', !leadsEarningConfigObj.is_active)}
            checked={leadsEarningConfigObj.is_active}
          />
        </div>
      </div>
    </div>
  </ React.Fragment>
};

export default FormPartial;
